import { render } from "./404.vue?vue&type=template&id=3d3b6360&scoped=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=3d3b6360&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3d3b6360"

export default script